"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { BookCatalog } from "@/lib/book-catalog";

const BookCatalogContext = createContext<BookCatalog | null>(null);

export function BookCatalogProvider({ catalog, children }: { catalog: BookCatalog | null; children: ReactNode }) {
  return <BookCatalogContext.Provider value={catalog}>{children}</BookCatalogContext.Provider>;
}

export function useBookCatalog(): BookCatalog | null {
  return useContext(BookCatalogContext);
}
